import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
import { KeyPadModule } from './key-pad-module/key-pad-module';
import { ConfirmButtonsComponent } from '@components/confirm-buttons';
import { DMGridComponent } from '@components/dm-grid/dm-grid.component';
import { ContentScrollComponent } from '@components/scroll/content-scroll';
import { ContentScrollCompactComponent } from '@components/scroll/content-scroll-compact';
import { ContentScrollPointerComponent } from '@components/scroll/content-scroll-pointer';
import { ScrollStateService } from '@components/scroll/scroll-state-service';
import { SharedModule } from '@shared/shared.module';
import { SearchBoxComponent } from './search-box';
import { TabSwitchComponent } from './tab-switch/tab-switch.component';

import { ModalComponentsCommonModule } from '@app/modules/modal-components-common/modal-components-common.module';

import { BreakDropdownComponent } from './dropdown/break-dropdown/break-dropdown.component';
import { UIDropdownComponent } from './dropdown/ui-dropdown/ui-dropdown.component';
import { FormCommonModule } from '@app/modules/form-common/form-common.module';
import { HeaderActionButtonsComponent } from './header-action-buttons';
import { DirectivesModule } from './directives/directives.module';
import { FooterButtonsComponent } from './footer-buttons/footer-buttons.component';
import { ListGridComponent } from './list-grid/list-grid.component';
import { GridHeaderComponent } from './grid-header/grid-header.component';
import { GlobalLoadingOverlayComponent } from './global-loading-overlay/global-loading-overlay.component';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { FilterSettingsComponent } from './filter-settings/filter-settings.component';
import { ButtonsComponent } from './buttons/buttons.component';
import {
  GRID_FILTER_COMPONENTS,
  GRID_RENDER_COMPONENTS,
  customGridComponents,
} from './dm-grid/dm-grid.common.components';

export const NEW_UI_COMPONENTS = [];

export const LAYOUT_COMPONENTS = [];

export const GRID_COMPONENTS = [
  DMGridComponent,
  GridHeaderComponent,
  ListGridComponent,
];

export const COMPONENTS = [
  ContentScrollComponent,
  ContentScrollCompactComponent,
  ContentScrollPointerComponent,
  ConfirmButtonsComponent,
  DMGridComponent,
  SearchBoxComponent,
  BreakDropdownComponent,
  UIDropdownComponent,
  HeaderActionButtonsComponent,
  FooterButtonsComponent,
  GlobalLoadingOverlayComponent,
  FilterPanelComponent,
  FilterSettingsComponent,
  ButtonsComponent,
  TabSwitchComponent,
];

@NgModule({
  declarations: [
    ...GRID_FILTER_COMPONENTS,
    ...LAYOUT_COMPONENTS,
    ...COMPONENTS,
    ...GRID_COMPONENTS,
    ...NEW_UI_COMPONENTS,
    ...GRID_RENDER_COMPONENTS,
    ...customGridComponents,
  ],
  exports: [
    ...LAYOUT_COMPONENTS,
    ...COMPONENTS,
    ...GRID_COMPONENTS,
    ...NEW_UI_COMPONENTS,
    ...GRID_RENDER_COMPONENTS,
    ...customGridComponents,
    TranslateModule,
  ],
  imports: [
    AgGridModule,
    CommonModule,
    FormsModule,
    DirectivesModule,
    KeyPadModule,
    ReactiveFormsModule,
    ModalComponentsCommonModule,
    FormCommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    ModalComponentsCommonModule,
  ],
  providers: [CurrencyPipe, ScrollStateService],
})
export class CommonComponentsModule {}
